export const linkifyConfig = {
  target: '_blank',
}
